import { UrlToJWT } from '@airasia-common/url-jwt-convertor';
import ssrData from './constants/ssrData';
import config from './config';
const jwtHash = '906a14a4c039ea4af65874742638ddae5c3ec9c6bbc9026eea35f00f';

let auth_p;
let getJWT;

try {
  auth_p = new UrlToJWT(config.REACT_APP_HOTEL_SSR_URL, jwtHash, ssrData);
  getJWT = async apiEndpoint => {
    try {
      const token = await auth_p.getToken(
        apiEndpoint === 'hotel-checkout'
          ? 'checkout'
          : apiEndpoint === 'review'
          ? 'details'
          : apiEndpoint
      );
      return token;
    } catch (e) {
      console.log('👺👺👺 jwt error: ', e);
      return '';
    }
  };
} catch (e) {
  console.log('👺👺👺 auth_p error: ', e);
}

export default getJWT;
